import { IComponentConfig } from "@/app/@types/base-component";
import {
    createMountsBottomFrameSortConfig,
    createMountsGlazingGasketConfig,
    createMountsSideFrameSortConfig,
    createMountsStripesConfig,
    // createMountsToptrackConfig,
    createMountsToptrackSlidingDoorConfig,
} from "../../base";
import { MountsService } from "@/app/services/mounts.service";
import { Partition } from "@/app/domain/entities/partition";

const createMountsToptrackSlidingDoorHardwaresConfig = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    partition: Partition,
): IComponentConfig => {
    const toptrackStuctureCode = MountsService.getTopTrack(partition);

    return createMountsToptrackSlidingDoorConfig()
        .structureType(toptrackStuctureCode)
        .qty(0)
        .area(1)
        .build();
};

// const createMountsToptrackHardwaresConfig = (
//     partition: Partition,
// ): IComponentConfig => {
//     const qty = MountsService.getTotalWidth(partition);
//     // now is only one of this type "mnt-toptrack-1"
//     return createMountsToptrackConfig()
//         .structureType("mnt-toptrack-1")
//         .qty(0).area(qty).build();
// };

const createMountsSideFrameSortHardwaresConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalHeight = MountsService.getTotalHeight(partition);
    const sides = 2;

    const qty = Math.round(totalHeight * sides) || 0;

    return createMountsSideFrameSortConfig().qty(0).area(qty).build();
};

const createMountsBottomFrameSortHardwaresConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const doorWidth = MountsService.getDoorTotalWidth(partition);

    const qty = Math.round(totalWidth - doorWidth) || 0;

    return createMountsBottomFrameSortConfig().qty(0).area(qty).build();
};

const createMountsGlazingGasketHardwaresConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const totalHeight = MountsService.getTotalHeight(partition);
    const doorWidth = MountsService.getDoorTotalWidth(partition);
    const hasTransom = MountsService.hasOverdoorTransom(partition);

    const sides = 2;
    const transomMultiplier = hasTransom ? 1 : sides;

    const totalDoorWidth = doorWidth * transomMultiplier;//top and bottom sides
    const horizontalGaskets = totalWidth * sides - totalDoorWidth;//top and bottom sides
    const verticalGaskets = totalHeight * sides;//left and right sides

    const qty = Math.round((horizontalGaskets + verticalGaskets) * sides) || 0; //inner and outer sides

    return createMountsGlazingGasketConfig().qty(0).area(qty).build();
};

const createMountsStripesHardwaresConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const lines = MountsService.getStipJointsQty(partition);
    // const length = lines * totalWidth; // changes due to task 869aha16k

    return createMountsStripesConfig()
        .qty(lines)
        .area(lines)
        .width(totalWidth)
        .build();
};

export const CGS200SlidingDoorsConfigs = (partition: Partition) => [
    // createMountsToptrackHardwaresConfig(partition),
    createMountsToptrackSlidingDoorHardwaresConfig(partition),
    createMountsSideFrameSortHardwaresConfig(partition),
    createMountsBottomFrameSortHardwaresConfig(partition),
    createMountsGlazingGasketHardwaresConfig(partition),
    createMountsStripesHardwaresConfig(partition),
];
